export const NO_OFFERS_OUTSIDE_SEASON_MESSAGE =
  'There are no offers for the chosen ski area and date range.';

export const SKIPASS_EXTENDS_BEYOND_SEASON_MESSAGE =
  'The requested skipass dates may extend beyond the operating season. We will offer a shorter skipass period aligned with the operating season of the chosen ski area.';

export const DATE_OUTSIDE_SEASON_MANUAL_MESSAGE =
  'This date is outside the operating season for this ski area.';
